export default __webpack_public_path__ + "static/media/img-46.621ee3d3.jpg";